<template>
  <ul>
    <li v-for="tag in tags" :key="tag.type">
      <filter-tag v-bind="tag" v-on="$listeners" />
    </li>
  </ul>
</template>

<script>
import FilterTag from '~/components/filter-tag'

export default {
  components: {
    FilterTag
  },
  props: {
    tags: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  
  ul {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      margin: $d-tiny / 2;
    }
  }
</style>
